import { useRoute } from "vue-router";
import { computed, type MaybeRefOrGetter, toValue } from "vue";

export default function useQueryParameter<TFallback extends MaybeRefOrGetter<string|undefined>>(key: string, fallback: TFallback|undefined = undefined) {
  const route = useRoute()

  const asString = computed(
    () => {
      if (!(key in route.query)) {
        return toValue(fallback)
      }

      const possibleArrayValue = route.query[key]
      const value = Array.isArray(possibleArrayValue) ? possibleArrayValue[0] : possibleArrayValue

      return value === null ? toValue(fallback) : value
    }
  )

  return {
    asString,
    asNumber: computed(
      () => {
        if (asString.value === undefined) {
          return undefined
        }

        const parsed = parseFloat(asString.value)

        return !isNaN(parsed) ? parsed : undefined
      }
    )
  }
}